var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('NavBar',{staticStyle:{"background-color":"#fff","border-bottom":"1px solid rgb(238, 238, 238)"}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("振合网平台隐私声明")])]),_c('div',{staticClass:"layout-page"},[_c('p',{staticClass:"details",domProps:{"innerHTML":_vm._s(_vm.noticeInfo)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }